import { ReactElement, ReactNode, useSyncExternalStore } from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

import { getImpersonation, subscribeImpersonation } from '@/lib/impersonation'
import { selectIsInternalAdmin } from '@/store/features/user/userSlice'

const InternalAdminRoute = ({ children }: { children: ReactNode }): ReactElement => {
  const isInternalAdmin = useSelector(selectIsInternalAdmin)
  const impersonating = useSyncExternalStore(subscribeImpersonation, getImpersonation)
  if (!isInternalAdmin || impersonating) return <Navigate to="/app/home" replace />
  return <>{children}</>
}

export default InternalAdminRoute
